import { LocaleMenu } from "@wa/ui";
import { useI18n } from "../i18n/I18nProvider";
import { usePlatformLocales, platformLocaleLabel } from "../lib/platformLocales";

/**
 * The language dropdown - the kit's `LocaleMenu`, which mirrors the public site's
 * `LanguageSwitcher` (a pill with flag + code + chevron, opening a list of flag +
 * name + check), so the self-service hub and the front end read as one product.
 * The one difference: web_account is an SPA, so it changes the UI language with
 * `setLocale` (I18nProvider) rather than by navigating (SEO is not a concern
 * inside an account hub).
 *
 * The languages are DYNAMIC (the platform catalogue, `usePlatformLocales`):
 * only languages whose ACCOUNT UI has a system translation are shown
 * (`system.account`; the base locales et/en always are). A superadmin adds
 * languages and translates the account interface from the admin centre's
 * Languages page.
 */
export function LanguageMenu() {
  const { locale, setLocale, t } = useI18n();
  const { locales: catalog } = usePlatformLocales();

  // Only languages whose account UI is translated. When the catalogue is
  // missing (the API is down, say), the fallback still yields the base et/en.
  const available = catalog.filter((l) => l.system?.account);
  const options = available.length ? available : catalog.filter((l) => l.code === "et" || l.code === "en");

  return (
    <LocaleMenu
      value={locale}
      options={options.map((o) => ({ code: o.code, label: platformLocaleLabel(catalog, o.code) }))}
      onChange={setLocale}
      triggerLabel={t("common.switchLanguage")}
      listLabel={t("common.languageList")}
    />
  );
}
